"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountTypes = exports._accountTypes = void 0;
exports._accountTypes = ['user', 'service'];
exports.accountTypes = [...exports._accountTypes];
